import React from "react";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useDialog } from "../../../contexts/DialogContext";
import SaveIcon from "@mui/icons-material/Save";

import { Grid, DialogActions, Button, CircularProgress } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useScheduleUser from "../../../hooks/useScheduleUser";

function ImmediateRenewalSchedule(props) {
  const { selectedRows, refreshPage, setSelectedRows } = props;
  const { immediateRenewalSchedule, isSubmitting } = useScheduleUser();
  const dispatch = useDispatch();
  const { unSetDialog } = useDialog();

  const methods = useForm();

  const onSubmit = async () => {
    try {
      if (!selectedRows || selectedRows.length === 0) {
        return dispatch(showErrorSnackbar("Please select the user"));
      }
      await immediateRenewalSchedule(selectedRows);
      dispatch(showSuccessSnackbar("Schedule User Renewed Successfully!"));
      refreshPage();
      setSelectedRows([]);
      unSetDialog("immediate_renewal_schedule");
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to Renew Schedule User"));
    }
  };

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item md={12}>
              <i>Do you want to renew the selected user schedule immediately?</i>
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              endIcon={isSubmitting ? <CircularProgress size={24} /> : null}
              disabled={isSubmitting}
            >
              Yes
            </Button>

            <Button
              variant="text"
              onClick={() => unSetDialog("immediate_renewal_schedule")}
              color="primary"
            >
              No
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default ImmediateRenewalSchedule;
